module.exports = __webpack_public_path__ + "img/logo_bukalapak.34d043ae.png";